<template>
  <div class="row">
    <template v-if="isLoanPending">
      <div class="col-md-12">
        <div
          class="alert alert-warning"
          role="alert"
        >
          {{ $t('label.hasLoanPanding') }}
        </div>
      </div>
    </template>
    <div class="col-md-6">
      <div class="form-input-mb">
        <label>{{ $t('input.placeholder.firstName') }}</label>
        <input
          v-model="data.name"
          :class="validations && validations.hasOwnProperty('name') ? 'form-input-error': ''"
          class="form-control"
          type="text"
        >
        <span
          v-if="validations && validations.hasOwnProperty('name')"
          class="label-error"
        >{{ validations.name[0] }}</span>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-input-mb">
        <label>{{ $t('input.placeholder.lastName') }}</label>
        <input
          v-model="data.last_name"
          :class="validations && validations.hasOwnProperty('last_name') ? 'form-input-error': ''"
          class="form-control"
          type="text"
        >
        <span
          v-if="validations && validations.hasOwnProperty('last_name')"
          class="label-error"
        >{{ validations.last_name[0] }}</span>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-input-mb">
        <label>{{ $t('input.placeholder.phoneNumber') }}</label>
        <input
          v-model="data.phone"
          v-mask="'0## ### ####'"
          :class="validations && validations.hasOwnProperty('phone') ? 'form-input-error': ''"
          class="form-control"
          type="text"
        >
        <span
          v-if="validations && validations.hasOwnProperty('phone')"
          class="label-error"
        >{{ validations.phone[0] }}</span>
      </div>
      <div class="form-input-mb">
        <label>{{ $t('input.placeholder.emailAddress') }}</label>
        <input
          v-model="data.email"
          :class="validations && validations.hasOwnProperty('email') ? 'form-input-error': ''"
          class="form-control"
          type="email"
        >
        <span
          v-if="validations && validations.hasOwnProperty('email')"
          class="label-error"
        >{{ validations.email[0] }}</span>
      </div>
    </div>
    <template v-if="logged">
      <div
        class="col-md-12"
        style="margin-top: 20px"
      >
        <button
          :class="isLoanPending ? 'btn-disabled' : ''"
          :disabled="isLoanPending"
          class="full-button"
          @click="requestNewLoan"
        >
          {{ $t('label.requestNewLoan').toUpperCase() }}
        </button>
      </div>
    </template>
    <template v-else>
      <div
        class="col-12"
        style="margin-top: 20px"
      >
        <button
          :class="isLoanPending ? 'btn-disabled' : ''"
          :disabled="isLoanPending"
          class="full-button"
          @click="applyNow"
        >
          {{ $t('button.applyNow').toUpperCase() }}
        </button>
      </div>
    </template>
    <div class="button-condition">
      {{ $t('label.condition.apply') }}
      <a
        class="link-condition"
        href="/privacy-policy"
      >{{ $t('label.privacyPolicy') }}</a> |
      <a
        class="link-condition"
        href="/term-and-conditions"
      >{{ $t('label.termAndConditions') }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'FormInputHeader',
  props: {
    // eslint-disable-next-line vue/require-prop-types
    validations: {
      default: null
    },
    isLoanPending: {
      type: Boolean,
      default: false
    },
    logged: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/require-default-prop
    applyNow: {
      type: Function
    },
    // eslint-disable-next-line vue/require-default-prop
    requestNewLoan: {
      type: Function
    }
  },
  computed: Object.assign(
    mapState({
      data: state => state.borrow
    })
  )
}
</script>

<style scoped>

</style>
